import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const listCloudProviderRegionsTE = <E = CF.API.ApiError>(
  { cloudProviderId }: { cloudProviderId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ListCloudProviderRegionsResponse> =>
  fetchTE<CF.API.Compute.ListCloudProviderRegionsResponse, E>(
    {
      path: `/api/_api/v2/cloud_providers/${cloudProviderId}/regions`,
      method: 'GET',
    },
    onRejected,
  );
